import React from "react";
import PageNavbar from "@/components/PageNavbar";
import Footer from "@/components/Footer";
import WhatsAppFAB from "@/components/WhatsAppFAB";
import MobileReserveBar from "@/components/MobileReserveBar";

// Shared layout for sub-pages (location, FAQ, blog).
// Keeps document.title + meta description in sync when the user navigates
// client-side between routes. For first-paint SEO, prerender.js bakes the
// title/description/canonical directly into the HTML file.
export const PageLayout = ({ title, description, children, testId }) => {
  React.useEffect(() => {
    if (title) document.title = title;
    if (description) {
      let el = document.querySelector('meta[name="description"]');
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute("name", "description");
        document.head.appendChild(el);
      }
      el.setAttribute("content", description);
    }
    window.scrollTo(0, 0);
  }, [title, description]);

  return (
    <main className="min-h-screen bg-ivory text-charcoal" data-testid={testId}>
      <PageNavbar />
      <div className="pt-28 md:pt-32">{children}</div>
      <Footer />
      <WhatsAppFAB />
      <MobileReserveBar />
    </main>
  );
};

export default PageLayout;
